import React, { useEffect, useState } from "react";
import axios from "axios";
import '../css/materiales.css'
import Logo from '../Images/logo.jpg'
import Fondo from '../Images/fondoPDF.jpg'
import { FaRegFilePdf } from "react-icons/fa6";
import Dashboard from "./Dashboard";

const Materiales = ({user, setUser}) => {

    const [materiales, setMateriales] = useState([])
    const [datosObra, setDatosObra] = useState([])

    useEffect(() => {
        getMateriales()
        getResidente()
    }, [])

    const getMateriales = async () => {
        try{
            const response = await axios.get('http://localhost:9000/materiales/' + user.idObra)
            console.log(response.data);
            if(response.data <= 1){
                alert("Todavia no hay resgistro")
            }
            setMateriales(response.data)
        }catch (error){
            alert("algo paso")
        }
        
    }

    const getResidente = async () => {
        const response = await axios.get('http://localhost:9000/obra/residente/' + user.idObra)
        setDatosObra(response.data)
    }

    function total(){
        var t = 0
        materiales.map(function (x){
            t += (x.cantEntMat) * (x.precioUni)
        })
        return t;
    }

    function number(x){
        return Number.parseFloat(x).toFixed(2)
    }

    return(
        <div>
            <Dashboard user={user} setUser={setUser}/>
            <table className="table">
                <thead>
                    <tr>
                        <th className="titulo-tabla" colspan="5"><h4>Materiales</h4></th>
                    </tr>
                </thead>
                <tr>
                    <th>ID</th>
                    <th>Nombre</th>
                    <th>Cantidad</th>
                    <th>Precio por Unidad</th>
                    <th>Total</th>
                </tr>
                {materiales.map((mat) => (
                    <tr key={mat.idEntMat}>
                        <td>{mat.idEntMat}</td>
                        <td>{mat.nombreMaterial}</td>
                        <td>{mat.cantEntMat}</td>
                        <td>$ {number(mat.precioUni)}</td>
                        <td>$ {number((mat.cantEntMat) * (mat.precioUni))}</td>
                    </tr>
                ))
                }
                <tr>
                    <th className="titulo-total" colspan="4">Total:</th>
                    <th>$ {number(total())}</th>
                </tr>
            </table>
            <div className="botones-accion">
                <button className="btn btn-danger"><span><FaRegFilePdf/> Generar</span></button>
            </div>
        </div>
        
    )
}

export default Materiales